import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { registerTokenGetter } from '@/infrastructure/api'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getMe } from '@/redux/api/user-api'
import { setTagsSentry, setUserSentry } from '@/infrastructure/sentry'
import { setUserPosthog, setGroupPosthog } from '@/infrastructure/posthog'

export function useAuth() {
  const dispatch = useAppDispatch()

  const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0()

  useEffect(() => {
    registerTokenGetter(getAccessTokenSilently)
  }, [getAccessTokenSilently])

  useEffect(() => {
    if (isLoading || !isAuthenticated) return
    dispatch(getMe())
  }, [dispatch, isLoading, isAuthenticated])

  const meCall = useAppSelector((store) => store.userApi.getMe)
  const me = meCall.response.user
  const loadingMe = meCall.loading

  useEffect(() => {
    if (loadingMe === 'succeeded') {
      if (!me?.name || !me?.group) return
      setUserSentry(me.name)
      setTagsSentry({ email: me.name, group: me.group })

      setUserPosthog(me.name, me.group)
      setGroupPosthog(me.group)
    }
  }, [loadingMe, me?.group, me?.name])

  return { isLoadingMe: loadingMe === 'pending' || isLoading }
}
